import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SkillsCheckerSummaryComponent} from './skills-checker-summary/skills-checker-summary.component';
import {SkillsCheckerFormComponent} from './skills-checker-form/skills-checker-form.component';
import {SkillsCheckerDevelopmentComponent} from './skills-checker-development/skills-checker-development.component';
import {SkillsCheckerTeamComponent} from './skills-checker-team/skills-checker-team.component';

const routes: Routes = [
    {
        path: '',
        component: SkillsCheckerSummaryComponent
    },
    {
        path: 'form/self/:del_id/:sc_id',
        component: SkillsCheckerFormComponent,
        data: {type: 'self'}
    },
    {
        path: 'form/manager/:del_id/:sc_id',
        component: SkillsCheckerFormComponent,
        data: {type: 'manager'}
    },
    {
        path: 'form/agreed/:del_id/:sc_id',
        component: SkillsCheckerFormComponent,
        data: {type: 'agreed'}
    },
    {
        path: 'development/my/:sc_id',
        component: SkillsCheckerDevelopmentComponent,
        data: {level: 'learner'}
    },
    {
        path: 'development/user/:del_id/:sc_id',
        component: SkillsCheckerDevelopmentComponent,
        data: {level: 'manager'}
    },
    {
        path: 'team',
        component: SkillsCheckerTeamComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SkillsCheckerRoutingModule {
}
